// Approved premium packaging (owner reference). Contents marked
// 'supplier-pending' must be confirmed before publication.

export type PackagingItem = {
  item: string;
  status: 'owner-approved' | 'supplier-pending';
};

export const packagingDesign: string[] = [
  'Deep navy exterior',
  'Metallic silver nautical crest',
  'Premium wave graphics',
  'Refined typography',
  'Black precision-cut interior',
];

/** Customer-facing box contents per light — confirmed items only. */
export const boxContents: string[] = [
  'M1 PRO Wireless RGB Light — 13 LEDs',
  'Magnetic Mount System base — 3.3 in matched diameter',
  'USB-C charging cable',
  'Waterproof mounting sealant',
  "Owner's guide",
  'Cleaning cloth for installation',
];

/** Remote controls per order, shown under the per-light box contents. */
export const remoteRule =
  'Remote controls per order: 1 with a single light · 2 with 2–4 lights · 3 with 6+ lights (1 in use + 2 spares). Remotes use 2 AAA batteries, not included.';

export const packagingContents: PackagingItem[] = [
  { item: 'M1 PRO Wireless RGB Light — 13 LED lenses', status: 'owner-approved' },
  { item: 'White matched-diameter base labeled “MAGNETIC MOUNT SYSTEM”', status: 'owner-approved' },
  { item: 'USB-C charging cable', status: 'owner-approved' },
  { item: 'Waterproof mounting sealant', status: 'owner-approved' },
  { item: 'Quick-start guide', status: 'supplier-pending' },
];
